export default "__VITE_ASSET__B7ZzkLOg__"